import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { Chart } from "chart.js";
import { display } from "@mui/system";

export default function CardLineChart({ years = [], selectedGlobalYear, selectedGlobalMonth }) {
  const [currency, setCurrency] = useState("");
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  // const [chartData, setChartData] = useState(null);
  // const [selectedYear, setSelectedYear] = useState("");
  // const [selectedMonth, setSelectedMonth] = useState("");

  const [chartData, setChartData] = useState();
  const [selectedYear, setSelectedYear] = useState(
    selectedGlobalYear || new Date().getFullYear().toString()
  );
  const [selectedMonth, setSelectedMonth] = useState(
    selectedGlobalMonth || (new Date().getMonth() + 1).toString()
  ); // Adding 1 because months are zero-indexed

  useEffect(() => {
  setSelectedYear(selectedGlobalYear); // Sync with global year when it changes
}, [selectedGlobalYear]);

    useEffect(() => {
    setSelectedMonth(selectedGlobalMonth);
  }, [selectedGlobalMonth]);

  const fetchData = async (year, month) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/Analytics/GetMonthlyExpenseDrandCr?groupId=${groupId}&year=${year}&months=${month}`
      );
      const data = await response.json();
      setChartData(data);
      // console.log(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(selectedYear, selectedMonth);
  }, [userId, selectedYear, selectedMonth]);

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
        console.log(data);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {
      }
    };

    fetchCurrencyData();
  }, []);

  useEffect(() => {
    if (chartData) {
      // Destroy the existing chart instance if it exists
      if (window.myLine) {
        window.myLine.destroy();
      }
      var config = {
        type: "line",
        data: {
          labels: chartData.map((item) => item.date),
          datasets: [
            {
              label: "Credit",
              backgroundColor: "rgb(50, 205, 50)",
              borderColor: "rgb(50, 205, 50)",
              data: chartData.map((item) => item.credit),
              fill: false,
              tension: 0.4,
            },
            {
              label: "Debit",
              fill: false,
              tension: 0.4,
              backgroundColor: "rgba(255,0,0,0.7)",
              borderColor: "rgba(255,0,0,0.7)",
              data: chartData.map((item) => item.debit),
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          plugins: {
            title: {
              display: false,
              text: "Sales Charts",
              font: {
                color: "Black",
              },
            },

            legend: {
              labels: {
                color: "Black",
              },
              align: "end",
              position: "bottom",
            },
            tooltip: {
              mode: "index",
              intersect: false,
            },
            hover: {
              mode: "nearest",
              intersect: true,
            },
            datalabels: {
              color: "brown",
              display: false,
              font: {
                weight: "bold",
                size: 16,
                family: "Courier",
              },
              formatter: (value) => {
                return value;
              },
            },
          },
          scales: {
            x: {
              ticks: {
                color: "rgba(8,8,8,.7)",
              },
              title: {
                display: true,
                text: "Date",
                color: "Black",
              },
              grid: {
                display: true,
                borderDash: [2],
                borderDashOffset: [2],
                color: "rgba(8, 8, 8, 0.3)",
                zeroLineColor: "rgba(8, 8, 8, 0)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
            y: {
              ticks: {
                color: "rgba(8,8,8,.7)",
              },
              title: {
                display: true,
                text: "Expenses",
                color: "Black",
              },
              grid: {
                borderDash: [3],
                borderDashOffset: [3],
                drawBorder: true,
                color: "rgba(8, 8, 8, 0.15)",
                zeroLineColor: "rgba(8, 8, 8, 0)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          },
          elements: {
            point: {
              radius: 4,
              hoverRadius: 2,
            },
          },
        },
      };
      var ctx = document.getElementById("line-chart").getContext("2d");
      window.myLine = new Chart(ctx, config);
    }
  }, [chartData]);

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
        <div className="rounded mr-4 pl-4 mt-4 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <div className="flex flex-col md:flex-row justify-between ">
                <div className=" md:mb-0">
                  <h2
                    className="text-blueGray-700 text-xl font-semibold"
                    style={{ fontSize: "1rem" }}
                  >
                    Monthly Credits And Debits ({currency})
                  </h2>
                </div>
                <div className="flex">
                  <div className="mr-4 md:mb-0">
                    <select
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                      className="bg-white text-black border border-blueGray-600 rounded px-6 py-1 outline-none focus:outline-none md:w-32"
                    >
                      {years.map((yr) => (
                        <option key={yr} value={yr}>
                          {yr}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <select
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      className="bg-white text-black border border-blueGray-600 rounded px-3 py-1 outline-none focus:outline-none md:w-40"
                      style={{ width: "115px" }}
                    >
                      {/* Populate with months */}
                      {Array.from({ length: 12 }, (_, i) => i + 1).map(
                        (month) => (
                          <option key={month} value={month}>
                            {new Date(
                              selectedYear,
                              month - 1,
                              1
                            ).toLocaleString("default", { month: "long" })}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 flex-auto">
          {/* Chart */}
          <div className="relative h-350-px">
            <canvas id="line-chart"></canvas>
          </div>
        </div>
      </div>
    </>
  );
}
